var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19C7.9957 19 6.14442 18.3448 4.64865 17.2369M10 19C9.95946 17.8243 16.76 14.4363 14.4415 13.4056C12.2522 12.4324 17.2388 10.7297 18.3334 13.4054M10 19C13.7654 19 16.9908 16.6876 18.3334 13.4054M10 1C7.9957 1 6.14442 1.65518 4.64865 2.76305M10 1C10.3649 2.37838 10.209 4.72164 11.7658 5.01353C13.7117 5.37839 14.5631 5.13515 14.4415 6.22974C14.3199 7.32434 14.8383 8.30255 15.536 8.17569C16.8739 7.93245 16.0675 7.97297 16.554 7C17.0404 6.02703 18.9315 8.2973 18.6325 7.44595M10 1C14.0834 1 17.5316 3.71939 18.6325 7.44595M4.64865 2.76305C2.435 4.40265 1 7.03374 1 10C1 12.9663 2.435 15.5974 4.64865 17.2369M4.64865 2.76305C5.33784 4.64834 5.61171 8.07839 8.23874 8.17569C11.5225 8.29731 11.6756 13.2838 11.554 14.5C11.4323 15.7162 7.20261 10.5 6.53611 14.0138C6.35909 14.947 3.18919 16.8117 4.64865 17.2369M18.3334 13.4054C18.7631 12.3549 19 11.2051 19 10C19 9.11281 18.8716 8.25561 18.6325 7.44595",
    stroke: "#0F1011",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeo);
export default __webpack_public_path__ + "static/media/geo.4910c84e6abccd4375dafd69bc71f6ac.svg";
export { ForwardRef as ReactComponent };